<template lang="html">
  <div class="">
    <si-container>
      <v-flex xs12>
        <v-card>
          <v-card-title class="hedline">
            Export
            
          </v-card-title>
          <v-card-text>
            <v-flex class="subtitle-2 py-0">Current Month Totals</v-flex>
            <v-flex class=" py-0">Total Sales: {{ _$(currentMonthTotals.total) }}</v-flex>
            <v-flex class=" py-0">Total Licence Fee: {{ _$(currentMonthTotals.licenseTotal) }}</v-flex>
          </v-card-text>
          <v-card-text>
            <v-layout 
            row 
            wrap
            >
              <v-flex xs12 sm6>
                <SiInputSelect
                  v-model="exportMonth"
                  label="Export month"
                  outlined
                  :items="months"
                  required
                />
                <SiInputSelect
                  v-model="exportFormat"
                  label="Export format"
                  outlined
                  :items="[{text: 'CSV', value: 'csv'}, {text: 'Xero', value: 'xero'}]"
                  required
                />
                <SiInputSelect
                  v-if="exportFormat === 'xero' && exportMonth" 
                  v-model="exportDocumentType"
                  label="Document type"
                  outlined
                  :items="xeroDocumentTypes"
                  required
                />
                <SiInputText
                  v-if="exportFormat === 'xero' && exportDocumentType && exportMonth" 
                  v-model="exportAccountCode"
                  label="Account code"
                  outlined
                  required
                />
                <SiInputText
                  v-if="exportFormat === 'xero' && exportDocumentType == 'invoice_license' && exportMonth " 
                  v-model="exportInvoiceNumber"
                  label="Invoice number"
                  outlined
                  required
                />
              </v-flex>
              <v-flex xs12>
                <v-btn
                  depressed
                  color="primary"
                  @click="exportData"
                >
                  Export
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
         
        </v-card>
      </v-flex>
    </si-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'
import Papa from 'papaparse'

export default {
  mixins: [ binder, helpers ],
  data () {
    return {
      transactions: {},
      exportMonth: null,
      exportFormat: null,
      exportDocumentType: null,
      exportAccountCode: '206',
      exportInvoiceNumber: 'INV-',
      xeroDocumentTypes: [
        {text: 'INVOICE - Full transactions', value: 'invoice_full'},
        {text: 'INVOICE - Licensing fees', value: 'invoice_license'},
      ]
    }
  },
  computed: {
    ...mapGetters([ '_assistanceTypes' ]),
    months () {
      return Object
        .keys(this.transactions)
        .map(value => {
            const year = Math.floor(value / 100); // Extract year
            const month = value % 100;           // Extract month
            const text = moment(`${year}-${month}`, 'YYYY-M').format('YYYY-MMM');
            return { text, value }
        })
        .reverse()
    },
    currentMonthTotals () {
      const currentMonthStamp = Number(moment().format('YYYYMM'))
      if (this.transactions && this.transactions[currentMonthStamp]) {
        return Object
          .values(this.transactions[currentMonthStamp])
          .reduce((acc, { total, licenseTotal }) => {
            acc.total += total
            acc.licenseTotal += licenseTotal
            return acc
          }, { total: 0, licenseTotal: 0})
      } else {
        return { total: 0, licenseTotal: 0 }
      }
    },
    selectedMonth () {
      return this.months.find(({ value }) => value === this.exportMonth).text
    }
  },
  beforeMount () {
    this.$bindRtdb('transactions', `accounting/transactions`)    
  },
  methods: {
    exportData () {
      const documentTypeInfo = this.exportFormat === 'xero'
        ? this.xeroDocumentTypes.find(({ value }) => value === this.exportDocumentType)
        : {text: 'CSV'}
      let Total = 0
      let TaxTotal = ""
      const Reference = `SI-${this.months.find(({ value }) => value === this.exportMonth).text}`
      // let invoiceTotals = {}
      const transactionList = Object.values(this.transactions[this.exportMonth])
      const hasErrors = transactionList.some(({ hasError }) => hasError)
      const hasEstimates = transactionList.some(({ hasEstimatedPrice }) => hasEstimatedPrice)
      const data = transactionList
        .map(transaction => {
          const { 
            id, 
            formattedDate, 
            productList,
            total, 
            clientName,
            clientEmail,
            licenseTotal,
            timestamp,
            stripeFee,
            refundReason,
            method,
            type,
          } = transaction
          const firstOfNextMonth = moment(timestamp).add(1, 'months').startOf('month')
          let InvoiceDate = ""
          let DueDate = moment().add(1, 'months').format('DD/MM/YYYY')
          let EmailAddress = ''
          let InvoiceNumber = this.exportInvoiceNumber
          let ContactName = clientName
          let UnitAmount = 0
          let LineAmount = 0
          let AccountCode = this.exportAccountCode
          let TaxAmount = "" 
          let Description = `${formattedDate ? formattedDate +' | ' : '' }${id}` 
  
          if (type !== 'refund') {
            Description += `\nServices: ${productList.map(p => `\n  - ${p}`).join('')}`;          
          } else {
            Description += `\nRefund: ${refundReason}`
          }


          if (this.exportFormat === 'xero') {
            if (this.exportDocumentType === 'invoice_full') {
              const fee = stripeFee
              ContactName = clientName
              EmailAddress = clientEmail || ''
              InvoiceDate = moment(timestamp).format('DD/MM/YYYY')
              DueDate = moment(timestamp).format('DD/MM/YYYY')
              InvoiceNumber = `${type === 'refund' ? 'CR' : 'INV'}-${id}`
              UnitAmount = Math.round((total - fee)) / 100
              LineAmount = Math.round((total - fee)) / 100 
              // TaxAmount = Math.round((total - fee)/ 11) / 100 
              // if (!invoiceTotals[id]) invoiceTotals[id] = { total: 0, tax: 0 }
              // invoiceTotals[id].total += Math.round(total - fee)/ 100
              // invoiceTotals[id].tax += TaxAmount
              // TaxTotal = TaxAmount
              Total = Math.round(total - fee) / 100
              if (method === 'invoice') return null
              if (method === 'stripe' && stripeFee > 0 && type !== 'refund') {
                Description += `\n\nStripe fee: $${fee / 100}`
              }
              
            }
            if (this.exportDocumentType === 'invoice_license') {
              const fee = Math.round(stripeFee * (licenseTotal/total))
              AccountCode = this.exportAccountCode
              ContactName = "Phidern Pty Ltd"
              EmailAddress = "dan@superinfo.com.au"
              InvoiceDate = firstOfNextMonth.format('DD/MM/YYYY')
              DueDate = firstOfNextMonth.add(1, 'months').endOf('month').format('DD/MM/YYYY')
              UnitAmount = Math.round((licenseTotal - fee)  ) / 100 
              LineAmount = Math.round((licenseTotal - fee) ) / 100 
              // TaxAmount = Math.round((licenseTotal - fee) / 11) / 100 
              // TaxAmount = ""
              // TaxTotal = ""
              // TaxTotal += (licenseTotal - fee) / 11
              Total += licenseTotal - fee 

              if (method === 'stripe' && stripeFee > 0 && type !== 'refund') {
                Description += `\n\nStripe fee - apportioned: ($${fee / 100})\nTotal: $${licenseTotal / 100} - ($${fee / 100})`
              }
            }  

            return {
              ContactName,
              EmailAddress,
              InvoiceNumber,
              InvoiceDate,
              DueDate,
              Quantity: 1,
              Description,
              UnitAmount,
              LineAmount,
              AccountCode,
              TaxAmount,
              Total,
              TaxTotal,
              Reference,
              Type: type !== "refund" ? "Sales Invoice" : "Sales credit note",
              _Id: id,
            }
          }
              return transaction
        })
        .filter(Boolean)
        .map(transaction => {
          if (this.exportFormat === 'xero') {
            const line = {
              ...transaction,
              InvoiceAmountPaid: 0,
              InvoiceAmountDue: Total,
              TaxType: "GST on Income",
              Currency: "AUD",
              Sent: "Unsent",
              Status: "Draft",
              Discount: "",
              TrackingName1: "Region",
              TrackingOption1: "",
              TrackingName2: "",
              TrackingOption2: "",
              POAddressLine1: "",
              POAddressLine2: "",
              POAddressLine3: "",
              POAddressLine4: "",
              POCity: "",
              PORegion: "",
              POPostalCode: "",
              POCountry: "",
              SAAddressLine2: "",
              SAAddressLine3: "",
              SAAddressLine4: "",
              SACity: "",
              SARegion: "",
              SAPostalCode: "",
              SACountry: "",
              // Reference: "",
              PlannedDate: "",
              _Id: transaction._Id
            }
            if (this.exportDocumentType === 'invoice_license') {
              // line.TaxTotal = Math.round(TaxTotal) / 100
              line.Total = Math.round(Total) / 100
            }
            return line
          }
          return {
            ...transaction,
            productList: transaction.productList.join('\n')
            }
        })
      console.log(data)
      const result = Papa.unparse(data)
      const errorText = hasErrors ? " (errors)" : ""
      const estimateText = hasEstimates ? " (estimated)" : ""
      this.downloadCSV(result, `SI-Export${errorText}${estimateText} - ${data.length} - ${this.selectedMonth} - ${documentTypeInfo.text}.csv`)
    },
    downloadCSV(csvData, filename = 'data.csv') {
      // Create a Blob from the CSV string
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });

      // Create a temporary <a> element to trigger download
      const link = document.createElement("a");

      if (navigator.msSaveBlob) { // For IE and Edge
        navigator.msSaveBlob(blob, filename);
      } else {
        // Create a URL for the blob and set it as the href
        const url = URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with the filename
        link.download = filename;

        // Append to the document and trigger click
        document.body.appendChild(link);
        link.click();

        // Clean up and remove the link
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    }
  }
}
</script>

<style lang="css" scoped>

</style>
